import React from 'react';
import { Container } from '@mui/material';
import { DetailOrderHeader, OrderBody } from '../../components';

const OrderDetail: React.FunctionComponent = function () {
    return (
        <Container maxWidth="lg">
            <DetailOrderHeader />
            <OrderBody />
        </Container>
    );
};

export default OrderDetail;
